(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsController', TabObjectsController);

    TabObjectsController.$inject = ['$scope', '$state', 'DataUtils', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjectsRedeployablesCounter', 'TabObjects'];

    function TabObjectsController($scope, $state, DataUtils, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjectsRedeployablesCounter, TabObjects) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.applyFilter = applyFilter;
        vm.predicates = pagingParams.predicates;
        vm.fleet = pagingParams.fleet;
        vm.objectType = pagingParams.objectType;
        vm.objectState = pagingParams.objectState;
        vm.toUpdate = pagingParams.toUpdate;
        vm.online = pagingParams.online;
        vm.tracked = pagingParams.tracked;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-objects";
        vm.currentStateFilter = "tab-objects-filter";
        vm.charToSearch = pagingParams.search;
        vm.tabObjects = [];
        //boolean to set page ready
        vm.pageReady = false;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.fleet = filter.fleet;
                vm.objectType = filter.objectType;
                vm.objectState = filter.objectState;
                vm.toUpdate = filter.toUpdate;
                vm.online = filter.online;
                vm.tracked = filter.tracked;
            }
        }

        vm.redeployObjCounter = TabObjectsRedeployablesCounter;

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (fromState.name === vm.currentState &&
                toState.name !== fromState.name &&
                (toState.name !== 'tab-objects-detail' &&
                    toState.name !== 'tab-objects-new' &&
                    toState.name !== 'tab-objects-edit' &&
                    toState.name !== 'tab-objects.delete' &&
                    toState.name !== 'tab-objects.rerunning' &&
                    toState.name !== 'tab-objects.redeployment' &&
                    toState.name !== 'tab-objects.maintenance' &&
                    toState.name !== 'tab-objects-properties')) {
                localStorage.removeItem(vm.currentStateFilter);
            }
        });
        vm.loadAll();

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                query: vm.charToSearch,
                sort: sort()
            };
            addFilter(body);
            TabObjects.query(body, onSuccess, onError);


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabObjects = data;
                vm.page = pagingParams.page;
                vm.pageReady = true;
                // transition(false);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                fleet: vm.fleet,
                objectType: vm.objectType,
                objectState: vm.objectState,
                toUpdate: vm.toUpdate,
                online: vm.online,
                tracked: vm.tracked
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function applyFilter(fleet, objectType, state, update, online, tracked) {
            var filter = {};
            filter.fleet = vm.fleet = fleet;
            filter.objectType = vm.objectType = objectType;
            filter.objectState = vm.objectState = state;
            filter.toUpdate = vm.toUpdate = update;
            filter.online = vm.online = online;
            filter.tracked = vm.tracked = tracked;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            loadAll();
        }

        function addFilter(body) {
            if (+vm.fleet.id !== -1) {
                body.fleetId = vm.fleet.id;
            }
            if (+vm.objectType.id !== -1) {
                body.typeId = vm.objectType.id;
            }
            if (+vm.objectState.id !== -1) {
                body.stateId = vm.objectState.id;
            }
            if (+vm.toUpdate.id !== -1) {
                body.toUpdate = vm.toUpdate.query;
            }
            if (+vm.online.id !== -1) {
                body.online = vm.online.query;
            }
            if (+vm.tracked.id !== -1) {
                body.tracked = vm.tracked.query;
            }
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.changeSimStatus = function(object, status) {
            object.simActive = status;
            TabObjects.simStatus(object, onSimSuccess, onSimError);

            function onSimSuccess() {
                AlertService.success(status ? "Activated" : "Blocked" + " Sim for object " + object.objectUniqueCode);
            }

            function onSimError() {
                AlertService.error("Error " + status ? "Activating" : "Blocking" + " Sim for object " + object.objectUniqueCode);
            }
        };
    }
})
();
